import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { ROUTE_PATHS } from '@/lib/index';
import Layout from '@/components/Layout';
import Home from '@/pages/Home';

export default function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path={ROUTE_PATHS.HOME} element={<Home />} />
        </Routes>
      </Layout>
    </Router>
  );
}
